<template>
  <v-app>
    <v-alert class="popAlert" v-if="displayAlert" :type="alertType" :color="color">
      <div style="text-align: center">{{ alertMessage }}</div>
      <template v-slot:close>
        <v-icon @click="closeAlert"> mdi-close</v-icon>
      </template>
    </v-alert>
    <v-navigation-drawer touchless permanent expand-on-hover v-model="drawer" color="role" app>
      <v-hover v-slot="{ hover }">
        <drawer :collapses="hover" />
      </v-hover>

      <template #append>
        <div class="text-center version-wrapper">
          <small class="role_inverse--text">{{ buildVersion }}</small>
        </div>
      </template>
    </v-navigation-drawer>
    <CustomDialog ref="confirm"></CustomDialog>

    <v-app-bar app flat dense v-if="isLoggedIn">
      <div class="d-flex align-center justify-space-between full-width">
        <v-spacer />
        <img src="@/assets/Logo/RML_logo.png" style="object-fit: contain; height: 50px" />
        <v-spacer />
        <template v-if="currentClinic">
          <VipIcon size="24" :membership="currentClinic.membership" class="mr-1" />
          <div class="clinic-name">{{ currentClinic.name | parseAndLocalize('en') }}</div>
        </template>
      </div>
    </v-app-bar>
    <!-- <v-app-bar app flat class="whatsappGrey" dense>
      <img src="@/assets/indexLogo@180h.png" style="height: 30px; padding: 2.5px" />
      <v-spacer />
      <div class="text--secondary">
        <small v-if="debug">DEBUG MODE </small>
        <small @click="triggerDebugMode">{{ buildVersion }}</small>
      </div>
      <v-spacer />
      <div style="padding-right: 10px">
        <h3>
          {{ profile && profile.name }} (<span style="text-transform: capitalize">{{ role }}</span
          >)
        </h3>
      </div>
      <a @click="myProfile" class="mr-8">
        <v-icon style="font-size: 30px"> mdi-account</v-icon>
      </a>
      <a @click="ssoLogout" v-if="isLoggedIn">
        <v-icon style="font-size: 30px"> mdi-logout-variant</v-icon>
      </a>
      <a v-else>
        <v-icon style="font-size: 30px"> mdi-login-variant</v-icon>
      </a>
    </v-app-bar> -->
    <v-main>
      <BlockedView v-if="loginBlocked" class="text-center">
        <div style="background-color: red; padding: 50px; border-radius: 100px">
          <h2 style="color: white; text-align: center; margin-bottom: 20px">
            Your working has been blocked
            <br />
            Please contact your manager
            <br />
            <template>
              <h3 v-if="loginBlocked.subcode === 'needApproval'">
                Your account need to be approve
              </h3>
              <h3 v-if="loginBlocked.subcode === 'workTimePeriod'">
                Your work time period expired
              </h3>
            </template>
          </h2>
          <v-btn @click="ssoLogout"> Got it</v-btn>
        </div>
      </BlockedView>
      <div class="fill-height" style="background-color: #f5f5f5" :class="routerViewClass" v-else>
        <router-view v-if="$route.meta.uniqueComponent" :key="$route.fullPath" />
        <router-view v-else />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import api from '@/api';
import { ssoLogout } from '@/api/auth/sso';
import BlockedView from '@/components/BlockedView';
import Drawer from '@/layout/partial/drawerNav';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomDialog from '@/components/CustomDialog';
import { getBuildVersion } from '@/services/utils';
import { crudRead } from '@/api/crud';
import { parseAndLocalize } from '@/services/filters';
import { RESTFUL, roles } from '@/data/constants';
import customDialog from '@/components/CustomDialog.vue';
import VipIcon from '@/components/VipIcon';
import { syncClinicUnreadBookingCount } from '@/plugins/app-state.js';

const passcode = 'fletrix';

export default {
  components: { BlockedView, Drawer, CustomDialog, VipIcon },
  data() {
    return {
      loginBlockedMessage: '',
      drawer: false,
      clickCount: 0,
      buildVersion: getBuildVersion(),
      unreadBookingTimeInterval: null,
    };
  },
  computed: {
    ...mapGetters('alert', ['alertType', 'displayAlert', 'alertMessage', 'color']),
    ...mapGetters('auth', [
      'profile',
      'role',
      'isLoggedIn',
      'loginBlocked',
      'isClinicStaff',
      'clinicId',
      'currentClinic',
    ]),
    ...mapGetters(['debug']),
    routerViewClass() {
      return this.$route.meta.fullscreen ? 'pa-0' : 'pb-4';
    },
  },
  watch: {
    loginBlocked() {
      if (this.loginBlocked) this.dialog = true;
    },
    clinicId: {
      handler(v) {
        if (this.isClinicStaff && v) this.loadClinic();
      },
      immediate: true,
    },
  },
  async mounted() {
    this.$root.$confirm = this.$refs.confirm;
  },
  methods: {
    ...mapActions('alert', ['closeAlert']),
    ...mapActions('auth', ['checkLoginStatus', 'setClinic']),
    ...mapMutations(['setDebug']),
    myProfile() {
      this.$router.push({ name: 'myProfile' }).catch(() => {});
    },
    async ssoLogout() {
      this.$root.$confirm
        .open('Confirm', 'Do you confirm to logout?', { color: 'primary' })
        .then(async confirm => {
          if (confirm) {
            await ssoLogout(api);
            try {
              await this.checkLoginStatus();
            } catch (e) {}
            await this.$router.push({ name: 'login' });
          }
        });
    },
    triggerDebugMode() {
      this.clickCount += 1;
      if (this.clickCount > 4) {
        const pw = window.prompt('enter passcode');
        if (pw === passcode) this.setDebug(true);
      }
    },
    async loadClinic() {
      try {
        const clinic = await crudRead(api, RESTFUL.clinicProfile.read, this.clinicId);
        // Set clinic data to store
        this.setClinic(clinic);
      } catch (error) {
        this.setClinic(null);
        console.error('Failed to load clinic name:', error);
      }
    },
  },
  provide() {
    return {
      ssoLogout: this.ssoLogout,
    };
  },
};
</script>

<style scoped lang="scss">
// ::v-deep .v-dialog--active {
//   border-radius: 20px;
// }

.popAlert {
  position: fixed;
  bottom: 0px;
  z-index: 900;
  width: 60%;
  left: calc((100% - 60%) / 2);
}
.version-wrapper {
  height: 28px;
}
.clinic-name {
  color: var(--dark-grey, #5c5c5c);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: right;
}
</style>
